module.exports = {
          srcSet: __webpack_public_path__ + "1f9c1fe858b3d0ebb83694f169c4f5b6-1168.png"+" 1168w",
          images:[ {path: __webpack_public_path__ + "1f9c1fe858b3d0ebb83694f169c4f5b6-1168.png",width: 1168,height: 210}],
          src: __webpack_public_path__ + "1f9c1fe858b3d0ebb83694f169c4f5b6-1168.png",
          toString:function(){return __webpack_public_path__ + "1f9c1fe858b3d0ebb83694f169c4f5b6-1168.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/AExZ9v1eavf/UF33/jxK9f8iM/f/Ljjl/19Upf97bJH+YVeq/zM74PsAN0b19z1L9v8wP/X+KTj1/yg39P8hMfX/O0TZ/2dos/4zP+P/IzLy9bxRMBu8kcLsAAAAAElFTkSuQmCC",
          width: 1168,
          height: 210
        }